module.exports = __webpack_public_path__ + "static/img/playas.8fd172d6.png";